import api, { fetchAllPages } from "./client";

export const usuariosApi = {
  getAll: () => fetchAllPages("/usuarios/"),
  create: (data) => api.post("/usuarios/", data),
  update: (id, data) => api.patch(`/usuarios/${id}/`, data),
  changePassword: (id, password) => api.patch(`/usuarios/${id}/password/`, { password }),
};
